import Emitter from '@resources/js/helpers/Emitter'
import { addDay } from '@formkit/tempo'

const DEFAULT_CHILD_AGE = 0

export default class FormStore extends Emitter {
	#data

	constructor() {
		super()
		this.#data = {
			checkIn: addDay(new Date(), 1),
			checkOut: addDay(new Date(), 2),
			adultsCount: 2,
			childrenCount: 0,
			children: [],
		}
	}

	getData() {
		return this.#data
	}

	getProperty(name) {
		return this.#data[name]
	}

	setProperty(name, value) {
		if (this.#data[name] === value) return

		// до emit 'change', щоб підписники одразу бачили актуальний масив дітей
		if (name === 'childrenCount') {
			this.#fillChildrenWithDefaultAge(value)
			this.#data.children.length = value
		}

		this.#updateProperty(name, value)

		if (name === 'childrenCount') this.emit('children-count-changed', value)
	}

	#updateProperty(name, value) {
		this.#data[name] = value
		this.emit('change', { name, value })
	}

	#fillChildrenWithDefaultAge(count) {
		for (let i = this.#data.children.length; i < count; i++) {
			this.#data.children[i] = { age: DEFAULT_CHILD_AGE }
		}
	}

	addChildObj(index, value) {
		// якщо зміниться значення DEFAULT_CHILD_AGE на >0
		// тут треба буде перевіряти явно -> value === '' || value == null
		const age = Number(value || DEFAULT_CHILD_AGE)

		this.#data.children[index] = { age }

		this.emit('child-object-add', { index, value })
	}

	removeChildObj() {
		const { children, childrenCount } = this.#data

		// children вже обрізано в setProperty - pop лише якщо щось лишилось зайве
		if (children.length > childrenCount) children.pop()

		this.emit('child-object-remove')
	}
}
